// src/modules/IntegratedMessaging/hooks/useCountries.ts

import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { CountriesApiAdapter, Country } from '../adapters/CountriesApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const adapter = new CountriesApiAdapter(httpClient);

/**
 * Hook para cargar todos los países.
 */
export const useCountries = () => {
  return useQuery<Country[], Error>({
    queryKey: ['countries'],
    queryFn: () => adapter.getAllCountries(),
    staleTime: 10 * 60 * 1000,
  });
};
